module.exports = __webpack_public_path__ + "img/email.40123c2.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/img/email.svg
// module id = ./assets/img/email.svg
// module chunks = 13 19